import React, { useState } from 'react';
import ReactPlayer from 'react-player';

interface VideoPreviewProps {
  videoUrl: string;
  height?: string | number | undefined
  width?: string | number | undefined
  style?: React.CSSProperties | undefined
}

const VideoPreview: React.FC<VideoPreviewProps> = ({ videoUrl, height, width, style }) => {

  return (
    <div>
      <div>
        <ReactPlayer
          style={style}
          url={videoUrl}
          width={width || "100%"}
          height={height || "320px"}
          playing={false}
          muted
          controls
        />
      </div>
    </div>
  );
};

export default VideoPreview;
